module.exports = __webpack_public_path__ + "img/affinity-diagram.f3fa14ba.png";